import {createSinglePathSVG} from './TEMPLATE'

export const Microphone_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2a3 3 0 0 0-3 3v6a3 3 0 1 0 6 0V5a3 3 0 0 0-3-3ZM7 5a5 5 0 0 1 10 0v6a5 5 0 0 1-10 0V5ZM5 11a1 1 0 0 1 1 1 6 6 0 0 0 12 0 1 1 0 1 1 2 0 8 8 0 0 1-7 7.938V23a1 1 0 1 1-2 0v-3.062A8 8 0 0 1 4 12a1 1 0 0 1 1-1Z',
})
